import { useForm } from '@form-ts/react';
import React, { useEffect } from 'react';
import { CheckboxField } from 'src/modules/form/components/CheckboxField';
import { FormError } from 'src/modules/form/types/FormError';

type Props = {
  readonly name: string;
  readonly label: NonNullable<React.ReactNode>;
  readonly checked: boolean;
  readonly disabled?: boolean;
  readonly onChange: (checked: boolean) => void;
};

export const ProjectListColumnToggle = ({
  name,
  label,
  checked,
  disabled,
  onChange,
}: Props): React.ReactElement => {
  const form = useForm<boolean, FormError>(name, {
    reinitialize: true,
    initialValues: checked,
  });

  useEffect(() => form.subscribe(() => {
    onChange(form.currentState.values);
  }), [form, onChange]);

  return (
    <CheckboxField
      field={form.field}
      label={label}
      disabled={disabled}
    />
  );
};
